<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <deposito-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import DepositoShowData from "./DepositoShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "DepositoShow",
        components: {CrudShow, DepositoShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'deposito.showing',
            }
        },
    }
</script>



